import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as logoutHaVXWqg8UAMeta } from "/app/pages/logout.vue?macro=true";
import { default as _91id_93tGokxCmjqxMeta } from "/app/pages/playlist/[id].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "playlist-id",
    path: "/playlist/:id()",
    component: () => import("/app/pages/playlist/[id].vue")
  }
]